
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.203.7a7.204 7.204 0 104.114 13.117l5.448 5.446c.049.05.128.05.175.004l1.026-1.027c.048-.047.043-.128-.003-.175l-5.377-5.376A7.204 7.204 0 007.202.699zm0 13.559a6.356 6.356 0 110-12.712 6.356 6.356 0 010 12.712z","fill":"#000"}})])
          )
        }
      }
    